export let BookingScreenType = /*#__PURE__*/function (BookingScreenType) {
  BookingScreenType["Default"] = "DEFAULT";
  BookingScreenType["Book"] = "BOOK";
  BookingScreenType["Treatment"] = "TREATMENT";
  BookingScreenType["PainDetails"] = "PAIN_DETAILS";
  BookingScreenType["DetailedView"] = "DETAILED_VIEW";
  BookingScreenType["Upselling"] = "UPSELLING";
  return BookingScreenType;
}({});